import {
  getImpersonationInfo,
  isImpersonating,
  stopImpersonation,
} from '@/utils/impersonation';

/**
 * Bannière affichée en haut de l'app quand un admin consulte "en tant que" un user.
 * Permet de revenir à la session admin d'origine.
 */
export function ImpersonationBanner() {
  if (!isImpersonating()) return null;
  const info = getImpersonationInfo();

  return (
    <div className="sticky top-0 z-[100] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950">
      <span>
        Mode admin — vous consultez en tant que{' '}
        <strong>{info?.name || info?.email || 'un utilisateur'}</strong>
      </span>
      <button
        type="button"
        onClick={stopImpersonation}
        className="rounded-md bg-amber-950 px-3 py-1 text-xs font-semibold text-white transition-colors hover:bg-amber-900"
      >
        Revenir à mon compte admin
      </button>
    </div>
  );
}
